module.exports = __webpack_public_path__ + "img/newslist-广告图-972x90.38d8cc1c.jpg";